import { z } from 'zod';
// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
import { ProcessCategorySchema } from '../process/process.schema';
/**
 * Process Chain Swimlane values
 * Determines vertical position in the swimlane visualization
 */ export const ChainSwimlaneSchema = z.enum([
    'strategic',
    'core',
    'support'
]);
/**
 * Process-to-Swimlane Mapping within a chain
 * Each process in a chain has a swimlane assignment and an order (position)
 */ export const ProcessSwimlaneMappingSchema = z.object({
    processId: z.string(),
    swimlane: ChainSwimlaneSchema,
    order: z.number().int().min(1)
});
/**
 * Process Chain Schema
 * Groups existing processes into a named E2E chain with optional hierarchy
 */ export const ProcessChainSchema = z.object({
    _id: z.string(),
    name: z.string(),
    description: z.string().optional(),
    category: ProcessCategorySchema,
    // Hierarchy
    parentChainId: z.string().nullable().optional(),
    // Process mappings (leaf chains)
    processSwimlaneMappings: z.array(ProcessSwimlaneMappingSchema),
    // Metadata
    departmentName: z.string().optional(),
    e2eLabel: z.string().optional(),
    typicalInputs: z.array(z.string()).optional(),
    createdBy: z.string(),
    createdAt: z.string(),
    updatedAt: z.string()
});

//# sourceMappingURL=process-chain.schema.js.map